import gql from 'graphql-tag'

export const UPDATE_ORGANIZATION_DOCUMENTS = gql`
mutation ($orgId:uuid!,$documents:jsonb!) {
update_Organizations(where:{id:{_eq:$orgId}}, _set:{documents:$documents}){
  returning{
  id
  }}
}
`